// Mirrors back/constants/planEntitlements.js — these are just the wire-format
// key names both sides agree on. The actual plan → feature/limit mapping lives
// only on the backend (returned via GET /api/restaurants/:id/subscription) so
// there is a single source of truth.
export const PLAN_FEATURE = Object.freeze({
  RESERVATIONS: "reservations",
  MANUAL_RESERVATIONS: "manualReservations",
  CUSTOMER_CLUB: "customerClub",
  ADVANCED_REPORTS: "advancedReports",
  REMOVE_BRANDING: "removeBranding",
});

export const PLAN_LIMIT = Object.freeze({
  MAX_MENUS: "maxMenus",
  MAX_GALLERY_PHOTOS: "maxGalleryPhotos",
  MAX_MENU_CATEGORIES: "maxMenuCategories",
  MAX_MENU_ITEMS: "maxMenuItems",
});
